import {
  getStardogConnection,
  stardogAsyncThunkWrapper,
} from 'vet-bones/utils';
import { refetchConnectionToken } from 'vet-bones/utils/portal';

import { connectionSelector } from 'src/selectors/connection';
import { isConnectedSelector } from 'src/selectors/isConnected';

export const createStardogAsyncThunk = stardogAsyncThunkWrapper({
  connectionSelector,
  getStardogConnection,
  refreshConnection: async ({ api: { dispatch }, connection }) => {
    if (!connection?.token) {
      return null;
    }

    const token = await refetchConnectionToken(connection.index);
    if (!token) {
      return null;
    }

    dispatch({
      type: 'connections/updatedConnectionToken', // action with literal here to avoid circular dependency
      payload: { token },
    });

    return { ...connection, token };
  },
  onConnectionRefused: ({ api: { dispatch, getState }, connection, err }) => {
    const message = isConnectedSelector(getState())
      ? 'DISCONNECTED'
      : (err as Error).message;
    const connectionFailureAction = {
      type: 'connections/requestValidateConnection/rejected', // literal here to avoid circular dependency
      payload: { message },
      error: { message },
      meta: {
        aborted: false,
        arg: { connection },
        condition: false,
        rejectedWithValue: false,
        requestId: 'string',
        requestStatus: 'rejected',
      },
    };
    dispatch(connectionFailureAction);
  },
  onConnectionUnauthorized: ({ api: { dispatch } }) => {
    dispatch({
      type: 'connections/disconnected', // action with literal here to avoid circular dependency
      payload: undefined,
    });
  },
});
